import axiosInstance from "../../utils/axiosInstance";
import axios from "axios";
import baseUrl from "../../config/api";

import { addError } from "../layout/layoutActions"; // for centralized error handling

// get devices
export const getAllDevicesStart = () => ({
  type: "GET_ALL_DEVICES_START",
});

export const getAllDevicesSuccess = (devices) => ({
  type: "GET_ALL_DEVICES_SUCCESS",
  payload: devices,
});

export const getAllDevicesFailure = () => ({
  type: "GET_ALL_DEVICES_FAILURE",
});

// Speed limit actions
export const assignSpeedLimitRequest = () => ({
  type: "ASSIGN_SPEED_LIMIT_REQUEST",
});

export const assignSpeedLimitSuccess = (updatedDevices) => ({
  type: "ASSIGN_SPEED_LIMIT_SUCCESS",
  payload: updatedDevices,
});

export const assignSpeedLimitFailure = (error) => ({
  type: "ASSIGN_SPEED_LIMIT_FAILURE",
  payload: error,
});
export const trackDevice=(deviceId)=>({
  type:"TRACK_DEVICE",
  payload:deviceId
})
// get devices thunk
export const getAllDevicesStartAsync = (userID, token) => {
  return async (dispatch) => {
    dispatch(getAllDevicesStart());
    try {
      const response = await axiosInstance.get(`/trackAPI/device/${userID}`, {
        headers: { Authorization: `bearer ${token}` },
      });
      dispatch(getAllDevicesSuccess(response.data));
    } catch (error) {
      dispatch(getAllDevicesFailure());
      if (error.response && error.response.status !== 401) {
        dispatch(
          addError(
            error.response?.data.error ||
              "Couldn't reach the server, please check your internet connection or try again later"
          )
        );
      }
    }
  };
};

// get device location
export const getDeviceLocationStart = () => ({
  type: "GET_DEVICE_LOCATION_START",
});

export const getDeviceLocationSuccess = (location) => ({
  type: "GET_DEVICE_LOCATION_SUCCESS",
  payload: location,
});

export const getDeviceLocationFailure = () => ({
  type: "GET_DEVICE_LOCATION_FAILURE",
});
//change device location
export const changeDeviceLocation=(deviceId,location)=>({
  type:"CHANGE_DEVICE_LOCATION",
  payload:{location:location,deviceId:deviceId}
})
// get devices thunk
export const getDeviceLocationStartAsync = (id, userID, token) => {
  return async (dispatch) => {
    dispatch(getDeviceLocationStart());
    try {
      const response = await axiosInstance.get(
        `/trackAPI/device/${id}/${userID}`,
        {
          headers: { Authorization: `bearer ${token}` },
        }
      );
      dispatch(getDeviceLocationSuccess(response.data));
    } catch (error) {
      dispatch(getDeviceLocationFailure());
      if (error.response && error.response.status !== 401) {
        dispatch(
          addError(
            error.response?.data.error ||
              "Couldn't reach the server, please check your internet connection or try again later"
          )
        );
      }
    }
  };
};

// Speed limit thunk
export const assignSpeedLimit =
  (userId, devicesId, speedLimit, token) => async (dispatch) => {
    dispatch(assignSpeedLimitRequest());
    try {
      const response = await axios.put(
        `${baseUrl}/trackAPI/speedLimit/${userId}`,
        { devicesId, speedLimit },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(assignSpeedLimitSuccess(response.data));
      dispatch({
        type: "ASSIGN_GEOFENCE_SUCCESS",
        payload: "Speed limit updated successfully for the selected devices",
      });
    } catch (error) {
      dispatch(
        assignSpeedLimitFailure(
          error.response?.data?.message || "Failed to assign speed limit."
        )
      );
    }
  };
